<template>
  <a @click="login(provider)">
    <slot/>
  </a>
</template>
<script>
import VButton from "./Button";
import { mapActions } from "vuex";

export default {
  name: 'SocialAuth',

  components: { VButton },

  props: {
    provider: {
      type: String,
      default: ''
    }
  },
  data: () => ({}),

  computed: {},

  mounted() {
    window.addEventListener('message', this.onMessage, false)
  },

  beforeDestroy() {
    window.removeEventListener('message', this.onMessage)
  },

  methods: {
    ...mapActions([ 'fetchOauthUrl', 'saveToken', 'fetchUser' ]),

    async login(provider) {
      const newWindow = openWindow('', 'Login')
      const { url } = await this.fetchOauthUrl(provider);
      newWindow.location.href = url
    },

    /**
     * @param {MessageEvent} e
     */
    onMessage(e) {
      if (!e.data.token) {
        return
      }
      this.saveToken({ token: e.data.token }).then(() => {
        this.fetchUser().then(() => {
          this.$router.push({path: '/quiz/curl-profile'})
        })
      })
    }
  }
}

function openWindow(url, title, options = {}) {
  if (typeof url === 'object') {
    options = url
    url = ''
  }

  options = { url, title, width: 600, height: 720, ...options }

  const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screen.left
  const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screen.top
  const width = window.innerWidth || document.documentElement.clientWidth || window.screen.width
  const height = window.innerHeight || document.documentElement.clientHeight || window.screen.height

  options.left = ((width / 2) - (options.width / 2)) + dualScreenLeft
  options.top = ((height / 2) - (options.height / 2)) + dualScreenTop

  const optionsStr = Object.keys(options).reduce((acc, key) => {
    acc.push(`${key}=${options[key]}`)
    return acc
  }, []).join(',')

  const newWindow = window.open(url, title, optionsStr)

  if (window.focus) {
    newWindow.focus()
  }

  return newWindow
}
</script>





// WEBPACK FOOTER //
// src/components/SocialAuth.vue